import { PropsWithChildren } from 'react';

import { Button, Icons, Typography, Stack, tokens } from '@cast/design-system';

import { setUserTriggeredDemoMode } from '@cast/infrastructure-demo';
import { useNavigate } from '@cast/infrastructure-organization';

export const OpDemoHeader = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  return (
    <Stack
      bgcolor="#EFEBFF"
      py={8}
      px={24}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      data-testid="demo-header"
    >
      <Stack direction="row" alignItems="baseline" gap={8}>
        <Typography variant="h6" color="indigo.500">
          Demo Experience
        </Typography>
        {children && (
          <Typography variant="P12R" color="indigo.300">
            {children}
          </Typography>
        )}
      </Stack>
      <Button
        size="sm"
        endIcon={<Icons.X />}
        // it has to be a button, not a link as links are deactivated in demo
        onClick={() => {
          setUserTriggeredDemoMode(false);
          navigate('/');
        }}
        sx={{
          border: tokens.theme.border.status.discovery,
          backgroundColor: 'transparent',
          color: 'indigo.400',
          '&:hover': {
            backgroundColor: 'transparent',
            color: 'indigo.400',
          },
        }}
        testId="exit-btn"
      >
        Exit Demo
      </Button>
    </Stack>
  );
};
